export default "/images/0fb73e6f8992437d3beb73b5b8bed669.png";